var render = function () {
  var _vm$festa$section2$tx, _vm$festa$section2$tx2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.festa ? _c('div', [_c('section', {
    staticClass: "text-left"
  }, [_c('h2', [_vm._v("행사 소개")]), _c('b', {
    domProps: {
      "innerHTML": _vm._s((_vm$festa$section2$tx = _vm.festa.section2.txt[0]) === null || _vm$festa$section2$tx === void 0 ? void 0 : _vm$festa$section2$tx.replace(/\n/g, '<br/>'))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm$festa$section2$tx2 = _vm.festa.section2.txt[1]) === null || _vm$festa$section2$tx2 === void 0 ? void 0 : _vm$festa$section2$tx2.replace(/\n/g, '<br/>'))
    }
  })]), _c('section', {
    staticClass: "text-left"
  }, [_c('h2', [_vm._v("행사 개요")]), _c('table', [_c('tbody', [_vm._l(_vm.festa.section3.table.list, function (item, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/\n/g, '<br />'))
      }
    })]), _c('td', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.input.replace(/\n/g, '<br />'))
      }
    })])])];
  })], 2)])]), _c('section', {
    staticClass: "text-left d-block"
  }, [_c('h2', [_vm._v("개최성과")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.festa.section4.txt[0])
    }
  })]), _c('section', {
    staticClass: "text-left d-block"
  }, [_c('h2', [_vm._v("프로그램")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.festa.section5.txt[0])
    }
  })]), _c('section', {
    staticClass: "text-left d-block"
  }, [_c('h2', [_vm._v("Partners")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.festa.section6.contents.frame2211.txt[0])
    }
  }), _vm._l(_vm.festa.section6.contents.frame2302.logoList, function (logoItems, row) {
    return [_c('v-row', {
      key: row
    }, [_vm._l(logoItems, function (_ref, col) {
      var src = _ref.src,
        url = _ref.url;
      return [_c('v-col', {
        key: col,
        attrs: {
          "cols": "3"
        }
      }, [_c('a', {
        attrs: {
          "href": url
        }
      }, [_c('v-img', {
        attrs: {
          "src": src,
          "contain": "",
          "height": "96"
        }
      })], 1)])];
    }), _c('v-spacer')], 2)];
  })], 2)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }